<template>
	<div id="footer">

		<div class="wrap clearfix">
			<div class="f-top clearfix">
				<dl class="f-t-list fl">
					<dt>客服热线</dt>
					<dd>020-81308388</dd>
				</dl>
				<dl class="f-t-list fl">
					<dt>售前咨询</dt>
					<dd>18122733881</dd>
				</dl>
				<dl class="f-t-list fl">
					<dt>业务合作</dt>
					<dd>box@yljr.onexmail.com</dd>
				</dl>
				<!-- <dl class="f-t-list fl">
					<dt>
						
					</dt>
					<dd>020-81308388</dd>
				</dl> -->
				<div class="f-t-list fl clearfix">
					<div class="logo-img fl">
						<img src="../assets/footer/xiao.jpg" alt="">
					</div>
					<div class="logo-text">
						<div>扫一扫</div>
						<div>
							免费试用艺品天下
						</div>
					</div>
				</div>
			</div>

			<div class="f-bottom clearfix">
				<dl class="fl f-b-list">
					<dt>产品中心</dt>
					<dd>
						<div @click="juTo('CustomProduct','/CustomProduct')">艺品天下店</div>
						<div @click="juTo('CustomProduct','/CustomProduct')">艺品溯源</div>
						<div @click="juTo('CustomProduct','/CustomProduct')">智能安全箱</div>
					</dd>
				</dl>
				<dl class="fl f-b-list">
					<dt>行业解决方案</dt>
					<dd>
						<div @click="juTo('About','/About')">智慧零售</div>
						<div @click="juTo('About','/About')">自助展厅</div>
						<div @click="juTo('About','/About')">智慧仓库</div>
					</dd>
				</dl>
				<dl class="fl f-b-list">
					<dt>成功案例</dt>
					<dd>
						<div @click="juTo('Investment','/Investment')">温州艺品天下</div>
						<div @click="juTo('Investment','/Investment')">平洲翡翠艺术馆</div>
						<div @click="juTo('Investment','/Investment')">仓储式直播基地</div>
						<div @click="juTo('Investment','/Investment')">仙游红木展销馆</div>
					</dd>
				</dl>
				<dl class="fl f-b-list">
					<dt>合作伙伴</dt>
					<dd>
						
						<div @click="juTo('link','http://www.gdiot.org/')">广东省物联网协会</div>
						<div @click="juTo('link','http://kjj.gz.gov.cn/')">广州市科技创新委员会</div>
						<div @click="juTo('link','http://www.yp-tx.com/')">温州艺品天下</div>
					</dd>
				</dl>
			</div>

			<div class="f-center">
				<div class="logo-box">
					<div class="logo-img">
						<img src="../assets/footer/indexfootlogo.png" alt="">
					</div>
					<div class="logo-tetx">
						<div class="t1">
							艺品天下平台
						</div>
						<div class="t2">
							商用物联网解决方案提供商
						</div>

					</div>
				</div>
				<div class="record-box"  @click="juTo('link','https://beian.miit.gov.cn')">
					粤ICP备2021067857号-1
				</div>
			</div>
		</div>

		





	</div>
</template>

<script>
  export default{
  	data(){
  		return{
  		}
  	},
	methods:{
      juTo(type,url){

		  if(type == 'Investment'){
			  this.$router.push(url);
		  }
		// 
		if(type == 'CustomProduct'){
			this.$router.push(url);
		}

		  if(type == 'About'){
			  this.$router.push(url);
		  }
		if(type == 'link'){
			window.location.href = url
		}

        
      }
    },
  }
</script>

<style scoped>
	@import url("../resource/css/footer.css");
</style>



// WEBPACK FOOTER //
// src/components/footer.vue